import type { AssignedQuizFilters } from '@repo/types/pagination';

import { FilterIcon } from 'lucide-react';

import QuizzesFiltersContent from '@/components/features/quizzes/header/QuizzesFiltersContent';
import { Button } from '@/components/ui/button';
import { Drawer, DrawerBody, DrawerContent, DrawerDescription, DrawerHeader, DrawerTitle, DrawerTrigger } from '@/components/ui/drawer';
import { SearchInput } from '@/components/ui/input';
import { filterLabels } from '@/lib/quiz';

interface QuizzesHeaderProps {
  onSearchChange: (value?: string) => void;
  filterValue?: string;
  onFilterChange: (value?: AssignedQuizFilters) => void;
}

export default function QuizzesHeader(quizzesHeaderProps: QuizzesHeaderProps) {
  const { onSearchChange, filterValue, onFilterChange } = quizzesHeaderProps;
  return (
    <div className={'border-border-primary bg-background flex w-full flex-col gap-3 rounded-2xl border p-4'}>
      <div className="flex flex-col gap-3 sm:flex-row">
        <div className="flex gap-3">
          <h2 className={'text-foreground text-xl font-semibold'}>Quizy</h2>

          <Drawer>
            <DrawerTrigger asChild>
              <Button variant={'outline'} className="ms-auto shrink-0 sm:hidden">
                <FilterIcon />
                {filterValue ? filterLabels[filterValue as AssignedQuizFilters] : 'Filtry'}
              </Button>
            </DrawerTrigger>
            <DrawerContent>
              <DrawerBody>
                <DrawerHeader className="border-border-primary border-b">
                  <DrawerTitle>Filtry</DrawerTitle>
                </DrawerHeader>
                <DrawerDescription className={'sr-only'}>Filtry quizu</DrawerDescription>
                <div className="p-3 sm:p-4">
                  <QuizzesFiltersContent value={filterValue} onValueChange={onFilterChange} />
                </div>
              </DrawerBody>
            </DrawerContent>
          </Drawer>
        </div>
        <SearchInput className="w-full grow sm:ms-auto sm:max-w-64" setValue={onSearchChange} placeholder={'Szukaj...'} />
      </div>

      <QuizzesFiltersContent value={filterValue} onValueChange={onFilterChange} className="hidden sm:flex" />
    </div>
  );
}
